import { BasicRuleFieldsProps } from './BasicRuleFields';
import { AutocompleteMultiSelectItem } from '@jupiterone/jupiter-web-toolkit';
import { useState, useEffect } from 'react';

export type UseBasicRuleFieldsLogicProps = Pick<
  BasicRuleFieldsProps,
  'rule' | 'onTagChange'
>;
const useBasicRuleFieldsLogic = ({
  rule,
  onTagChange,
}: UseBasicRuleFieldsLogicProps) => {
  const [selectedTags, setSelectedTags] = useState<
    AutocompleteMultiSelectItem[]
  >([]);

  useEffect(() => {
    setSelectedTags(
      () => rule.tags?.map((tag) => ({ id: tag, title: tag })) ?? []
    );
  }, []);

  useEffect(() => {
    const newTags = selectedTags.map((tag) => tag.title);
    const updatedRule = { ...rule, tags: newTags };
    onTagChange(updatedRule);
  }, [selectedTags]);

  return {
    selectedTags,
    setSelectedTags,
  };
};

export default useBasicRuleFieldsLogic;
